var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgParentsGroup({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "122px",
    height: "130px",
    viewBox: "0 0 122 130",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "BTI_parents") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Website",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop_Research",
    transform: "translate(-799.000000, -845.000000)",
    stroke: "#006AF9",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("g", {
    id: "parents",
    transform: "translate(801.000000, 847.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.6105263,16 C41.6105263,24.8365012 34.5342148,32 25.8052632,32 C17.0763115,32 10,24.8365012 10,16 C10,7.16349879 17.0763115,0 25.8052632,0 C34.5342148,0 41.6105263,7.16349879 41.6105263,16 Z",
    id: "Stroke-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.990719258,97 L0.990719258,51.4222726 C0.990719258,44.589993 6.5944015,39 13.4434126,39 L37.5380259,39 C44.387037,39 49.9907193,44.589993 49.9907193,51.4222726 L49.9907193,57.6037176",
    id: "Stroke-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.610526,24 C109.610526,32.8365012 102.534268,40 93.805144,40 C85.0764964,40 78,32.8365012 78,24 C78,15.1634988 85.0764964,8 93.805144,8 C102.534268,8 109.610526,15.1634988 109.610526,24 Z",
    id: "Stroke-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.9907193,57.5784931 C69.7639899,51.4733237 75.1224162,47 81.4434126,47 L105.538026,47 C112.387037,47 117.990719,52.5900216 117.990719,59.4223362 L117.990719,105",
    id: "Stroke-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.2959824,72 C75.2959824,80.8365012 68.2199092,88 59.4907193,88 C50.7620058,88 43.6854561,80.8365012 43.6854561,72 C43.6854561,63.1634988 50.7620058,56 59.4907193,56 C68.2199092,56 75.2959824,63.1634988 75.2959824,72 Z",
    id: "Stroke-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.9907193,126 L34.9907193,107.275363 C34.9907193,100.523884 40.5943675,95 47.4436346,95 L71.5378039,95 C78.3870711,95 83.9907193,100.523884 83.9907193,107.275363 L83.9907193,126",
    id: "Stroke-11"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParentsGroup);
export default __webpack_public_path__ + "static/media/Parents_group.aa38bd2fb8623a5759434f2cc7e056a9.svg";
export { ForwardRef as ReactComponent };